import webBiLogger from '@wix/web-bi-logger';
import initSchemaLogger from 'bi-logger-hap';

const logger = initSchemaLogger(webBiLogger)();

import { EditorType, SwitchType } from './types';

export class BiLogger {
  private readonly siteHistorySessionId: string;

  constructor(msid: string) {
    this.siteHistorySessionId = `${Date.now()}.${msid}`;
  }

  //evid: 250
  reportPageStart(): void {
    logger
      .revisionsPageStart({
        sessionId: this.siteHistorySessionId,
      })
      .catch(() => {});
  }

  //evid: 251
  reportPageLoadComplete(
    revisionsLoadTime: number,
    pageLoadTime: number,
    adiRevisions: number,
    editorRevisions: number,
  ): void {
    logger
      .revisionsPageCompleteLoad({
        sessionId: this.siteHistorySessionId,
        g1: Math.round(revisionsLoadTime),
        loadTime: Math.round(pageLoadTime),
        adiRevisions,
        editorRevisions,
      })
      .catch(() => {});
  }

  //evid: 270
  reportPagePerformance(): void {
    if (window.performance && window.performance.timing) {
      logger
        .revisionsReportPagePerformance({
          sessionId: this.siteHistorySessionId,
          serverLoadTime: Math.round(
            performance.timing.responseEnd - performance.timing.fetchStart,
          ), // server part
          clientProcessTime: Math.round(
            performance.timing.domInteractive - performance.timing.responseEnd,
          ), // client part
        })
        .catch(() => {});
    }
  }

  //evid: 252
  reportViewRevisionClicked(
    revision: number,
    revisionDateCreated: Date,
    revisionBuilder: EditorType,
  ): void {
    logger
      .revisionsViewClick({
        g1: revision,
        sessionId: this.siteHistorySessionId,
        revisionDateCreated: revisionDateCreated.getTime(),
        revision_builder: revisionBuilder,
      })
      .catch(() => {});
  }

  //evid: 253
  reportRestoreRevisionClicked(
    revision: number,
    revisionDateCreated: Date,
    revisionBuilder: EditorType,
    popupType: SwitchType,
  ): void {
    logger
      .revisionsRestoreClick({
        sessionId: this.siteHistorySessionId,
        g1: revision,
        revisionDateCreated: revisionDateCreated.getTime(),
        revision_builder: revisionBuilder,
        popup_type: popupType,
      })
      .catch(() => {});
  }

  //evid: 254
  reportCancelRestoreClicked(
    revision: number,
    revisionDateCreated: Date,
    revisionBuilder: EditorType,
    popupType: SwitchType,
  ): void {
    logger
      .revisionsRestorePopupCancel({
        sessionId: this.siteHistorySessionId,
        g1: revision,
        revisionDateCreated: revisionDateCreated.getTime(),
        revision_builder: revisionBuilder,
        popup_type: popupType,
      })
      .catch(() => {});
  }

  //evid: 255
  reportConfirmRestoreClicked(
    revision: number,
    revisionDateCreated: Date,
    revisionBuilder: EditorType,
    popupType: SwitchType,
  ): void {
    logger
      .revisionsRestorePopupConfirm({
        sessionId: this.siteHistorySessionId,
        g1: revision,
        revisionDateCreated: revisionDateCreated.getTime(),
        revision_builder: revisionBuilder,
        popup_type: popupType,
      })
      .catch(() => {});
  }

  //evid: 256
  reportGoToEditorClicked(revision: number, revisionDateCreated: Date): void {
    logger
      .revisionsRestoreSuccessGoToEditor({
        sessionId: this.siteHistorySessionId,
        revisionDateCreated: revisionDateCreated.getTime(),
        g1: revision,
      })
      .catch(() => {});
  }

  //evid: 257
  reportStayInPageClicked(revision: number, revisionDateCreated: Date): void {
    logger
      .revisionsRestoreSuccessStayInPage({
        sessionId: this.siteHistorySessionId,
        revisionDateCreated: revisionDateCreated.getTime(),
        g1: revision,
      })
      .catch(() => {});
  }

  //evid: 258
  reportRestoreFailed(
    revision: number,
    revisionDateCreated: Date,
    revisionBuilder: EditorType,
    switchBuilder: boolean,
  ): void {
    logger
      .revisionsRestoreFailed({
        sessionId: this.siteHistorySessionId,
        g1: revision,
        revisionDateCreated: revisionDateCreated.getTime(),
        revision_builder: revisionBuilder,
        switch_builder: switchBuilder,
      })
      .catch(() => {});
  }

  //evid: 268
  reportRestoreSuccess(
    revision: number,
    revisionDateCreated: Date,
    revisionBuilder: EditorType,
    loadTime: number,
    switchBuilder: boolean,
  ): void {
    logger
      .revisionsRestoreRevisionSuccess({
        sessionId: this.siteHistorySessionId,
        g1: revision,
        loadTime: Math.round(loadTime),
        revisionDateCreated: revisionDateCreated.getTime(),
        revision_builder: revisionBuilder,
        switch_builder: switchBuilder,
      })
      .catch(() => {});
  }

  //evid: 267
  reportViewSuccess(
    revision: number,
    revisionDateCreated: Date,
    revisionBuilder: EditorType,
    loadTime: number,
  ): void {
    logger
      .revisionsRevisionViewSuccess({
        sessionId: this.siteHistorySessionId,
        g1: revision,
        loadTime: Math.round(loadTime),
        revisionDateCreated: revisionDateCreated.getTime(),
        revision_builder: revisionBuilder,
      })
      .catch(() => {});
  }

  //TODO find out what's the issue here
  //evid: 261
  // reportGoToMyAccountClicked(): void {
  //   logger.revisionsCloseRevisionsFrame({
  //     sessionId: this.siteHistorySessionId
  //   }).catch(() => {});
  // }

  //TODO find out what's the issue here
  //evid: 262
  // reportHelpButtonClicked(): void {
  //   logger.revisionsClickHelpButton({
  //     sessionId: this.siteHistorySessionId
  //   }).catch(() => {});
  // }

  //evid: 263
  reportMinimizeSideBar(): void {
    logger
      .revisionsMinimizeSidebar({
        sessionId: this.siteHistorySessionId,
      })
      .catch(() => {});
  }

  //evid: 264
  reportMaximizeSideBar(): void {
    logger
      .revisionsMaximizeSidebar({
        sessionId: this.siteHistorySessionId,
      })
      .catch(() => {});
  }

  //evid: 265
  reportRevisionStarred(
    revision: number,
    revisionDateCreated: Date,
    revisionBuilder: EditorType,
  ): void {
    logger
      .revisionsFlagRevision({
        sessionId: this.siteHistorySessionId,
        g1: revision,
        revisionDateCreated: revisionDateCreated.getTime(),
        revision_builder: revisionBuilder,
      })
      .catch(() => {});
  }

  //evid: 266
  reportRevisionRenamed(revision: number, revisionDateCreated: Date): void {
    logger
      .revisionsRenameRevision({
        sessionId: this.siteHistorySessionId,
        revisionDateCreated: revisionDateCreated.getTime(),
        g1: revision,
      })
      .catch(() => {});
  }

  //evid: 269
  reportRevisionsFiltered(filterName: string): void {
    logger
      .revisionsFilterInRevisionPage({
        sessionId: this.siteHistorySessionId,
        filter_type: filterName,
      })
      .catch(() => {});
  }
}
